export * from './src/ui-bootstrap';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/public_api.js
// module id = 768
// module chunks = 3